(function() {
    "use strict";

    angular
        .module('ccsTrApp')
        .service('LotCustomService', LotCustomService);

    LotCustomService.$inject = ['$http'];

    function LotCustomService($http) {
        return {
            getSiByContract: getSiByContract,
            saveImportLots: saveImportLots,
            saveImportLotsShipment: saveImportLotsShipment,
            allocateLots: allocateLots,
            allocateLotsToShipment: allocateLotsToShipment,
            releaseLot: releaseLot,
            releaseLots: releaseLots,
            splitLots: splitLots,
            returnSelectedLots: returnSelectedLots,
            returnLotByShipment: returnLotByShipment,
            returnMinifiedLotsByShipment: returnMinifiedLotsByShipment,
            returnLotByPurchContract: returnLotByPurchContract,
            returnAvailableQtyByPurchContract: returnAvailableQtyByPurchContract,
            returnAvailableQtyBySaleContract: returnAvailableQtyBySaleContract,
            returnNoSiLotsByPurchContract: returnNoSiLotsByPurchContract,
            returnLotBySaleContract: returnLotBySaleContract,
            returnLotsByStatus: returnLotsByStatus,
            assignShipmentToLots: assignShipmentToLots,
            applySaleContractStuff: applySaleContractStuff,
            lotsEligibleForFixation: lotsEligibleForFixation,
            returnLotByPurchContractShipment: returnLotByPurchContractShipment,
            returnLotBySaleContractShipment: returnLotBySaleContractShipment,
            getMinifiedLotsForInvoiceDialogByContractTypeAndContractAndShipment: getMinifiedLotsForInvoiceDialogByContractTypeAndContractAndShipment,
            returnUsedContracts: returnUsedContracts,
            returnUsedShipments: returnUsedShipments,
            returnUsedGrowths: returnUsedGrowths,
            returnUsedCompanies: returnUsedCompanies,
            returnUsedInvoices: returnUsedInvoices,
            returnUsedShipmentBlNumbers: returnUsedShipmentBlNumbers,
            returnUsedShipmentLcNumbers: returnUsedShipmentLcNumbers,
            returnLotsByShipmentContract: returnLotsByShipmentContract,
            getMinifiedLotsByShipmentContract: getMinifiedLotsByShipmentContract,
            returnLotAuditById: returnLotAuditById,
            returnMinifiedLot: returnMinifiedLot,
            returnMinifiedLotIds: returnMinifiedLotIds
        };

        function returnLotAuditById(id) {
            var url = "jv/audit/lots/" + id;
            return $http.get(url);
        }

        function returnUsedContracts(contractType) {
            var url = "api/lots/contracts/filter?contractType=" + contractType;
            return $http.get(url);
        }

        function returnMinifiedLot(id) {
            var url = "api/lots/" + id + "/minified";
            return $http.get(url);
        }

        function returnUsedShipments() {
            var url = "api/lots/shipments/filter";
            return $http.get(url);
        }

        function returnUsedGrowths() {
            var url = "api/lots/growths/filter";
            return $http.get(url);
        }

        function returnUsedCompanies(type) {
            var url = "api/lots/companies/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedInvoices(type) {
            var url = "api/lots/invoices/filter?type=" + type;
            return $http.get(url);
        }

        function returnUsedShipmentBlNumbers() {
            var url = "api/lots/blNumbers/filter";
            return $http.get(url);
        }

        function returnUsedShipmentLcNumbers() {
            var url = "api/lots/lcNumbers/filter";
            return $http.get(url);
        }

        function getSiByContract(id) {
            var url = "api/contracts/si/" + id;
            return $http.get(url);
        }

        function saveImportLots(lots, id) {
            var url = "api/lots/import?contractId=" + id;
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function saveImportLotsShipment(lots, purchId, saleId) {
            var url = "api/lots/shipment/import?purchContractId=" + purchId + "&saleContractId=" + saleId;
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type:': 'application/json'}
            });
        }

        function allocateLots(lots) {
            var url = "api/lots/allocate";
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function allocateLotsToShipment(lots) {
            var url = "api/lots/allocate/shipment";
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function releaseLot(id) {
            var url = "api/lots/unallocate/" + id;
            return $http.post(url);
        }

        function releaseLots(lotGridDTOs) {
            var url = "api/lots/unallocate";
            return $http({
                url: url,
                method: "POST",
                data: lotGridDTOs,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function splitLots(lots) {
            var url = "api/lots/split";
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function returnSelectedLots(lotMinDTOs) {
            var url = "api/lots/selected";
            return $http({
                url: url,
                method: "POST",
                data: lotMinDTOs,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function returnLotByShipment(id) {
            var url = "api/lots/shipment/" + id;
            return $http.get(url);
        }

        function returnMinifiedLotsByShipment(id) {
            var url = "api/lots/minified/shipment/" + id;
            return $http.get(url);
        }

        function returnMinifiedLotIds(ids) {
            var url = "api/lots/minified?ids=" + ids;
            return $http.get(url);
        }

        function returnLotsByShipmentContract(sid, cid, invoiceType) {
            var url = "api/lots/shipment/" + sid + "/contract/" + cid + "/invoice/" + invoiceType;
            return $http.get(url);
        }

        function getMinifiedLotsByShipmentContract(sid, cid, invoiceType) {
            var url = "api/lots/minified/shipment/" + sid + "/contract/" + cid + "/invoice/" + invoiceType;
            return $http.get(url);
        }

        function returnLotByPurchContract(id) {
            var url = "api/lots/purchContract/" + id;
            return $http.get(url);
        }

        function returnLotByPurchContractShipment(id, shipmentId) {
            var url = "api/lots/purchContract/" + id + "/shipment/" + shipmentId;
            return $http.get(url);
        }

        function getMinifiedLotsForInvoiceDialogByContractTypeAndContractAndShipment(contractType, id, shipmentId) {
            var url = "api/lots/minified/invoice-dialog/type/" + contractType + "/contract/" + id + "/shipment/" + shipmentId;
            return $http.get(url);
        }

        function returnAvailableQtyByPurchContract( id ) {
            var url = "api/lots/purchContract/" + id + "/available-qty";
            return $http.get( url );
        }

        function returnAvailableQtyBySaleContract( id ) {
            var url = "api/lots/saleContract/" + id + "/available-qty";
            return $http.get( url );
        }

        function returnNoSiLotsByPurchContract(id, page, pageSize, sortField, sortDirection, filter) {
            var queryParams = "?page=" + page + "&size=" + pageSize + "&sort=" + sortField + "," + sortDirection;
            var queryParamsFilter = "&lotRef=" + filter.lotRef + "&cropYear=" + filter.cropYear + "&loadingPlace=" + filter.loadingPlace
                + "&qtyBalesFrom=" + (filter.qtyBalesFrom > 0 ? filter.qtyBalesFrom : '')
                + "&qtyBalesTo=" + (filter.qtyBalesTo > 0 ? filter.qtyBalesTo : '')
                + "&purchaseContractId=" + (filter.purchaseContractId > 0 ? filter.purchaseContractId : '');
            for (var i = 0; i < filter.purchaseContractsId.length; i++) {
                queryParamsFilter += "&purchaseContractsId=" + filter.purchaseContractsId[i];
            }
            var url = "api/lots/shipment/null" + queryParams + queryParamsFilter;
            return $http.get(url);
        }

        function returnLotBySaleContract(id) {
            var url = "api/lots/saleContract/" + id;
            return $http.get(url);
        }

        function returnLotBySaleContractShipment(id, shipmentId) {
            var url = "api/lots/saleContract/" + id + "/shipment/" + shipmentId;
            return $http.get(url);
        }

        function returnLotsByStatus(status) {
            var url = "api/lots/status/" + status;
            return $http.get(url);
        }

        // function assignShipmentToLots( lots, contract, shipment ) {
        function assignShipmentToLots(lots, shipment, saleContract) {
            angular.forEach(lots, function (value, key) {
                if (lots[key].lotStatus === "AVAILABLE") {
                    lots[key].lotStatus = "ALLOCATED";
                }
                lots[key].purchSi = shipment;
                if (null !== saleContract && saleContract !== undefined) {
                    lots[key].allocSi = shipment;
                    lots[key].allocSale = saleContract;
                }
            });
            var url = "api/lots/assign/shipment";
            return $http({
                url: url,
                method: "POST",
                data: lots,
                headers: {'Content-Type': 'application/json'}
            });
        }

        function applySaleContractStuff(lot, saleContract) {
            lot.allocSale = saleContract;
            //TODO -- this will likely change due to clients' additional requirements
            switch (saleContract.priceModel) {
                case 'FIXED':
                    lot.salePriceUnit = saleContract.fixedPriceType;
                    lot.salePrice = saleContract.fixedPrice;
                    lot.saleWtType = saleContract.fixedPriceUnitType;
                    break;
                case 'ONCALL':
                    lot.salePriceUnit = saleContract.onCallPriceType;
                    lot.salePrice = saleContract.onCallPrice;
                    lot.saleWtType = saleContract.onCallPriceUnitType;
                    break;
            }
            return lot;
        }

        function lotsEligibleForFixation(contractId, contractType) {
            var url = "api/lots/eligible-for-fixation?contractId="
                + contractId + "&contractType=" + contractType;
            return $http.get(url);
        }
    }
})();
